import React from "react"
import Board from "./components/dnd/Board"
const DNDTestPage = () => {
    return (
        <>
            <Board />
        </>
    )
}
export default DNDTestPage